import { ref } from 'vue';

export function usePartnershipWarning() {
  const showPartnershipWarningModal = ref(false);
  const pendingCourseAction = ref(null);

  const shouldShowPartnershipWarning = (course, selectedOffering = null) => {
    // If a specific offering is provided, use its offering-level flag
    if (selectedOffering) {
      return selectedOffering.shouldShowPartnerCoveredCourseWarning || false;
    }

    return false;
  };

  const handlePartnershipWarning = (course, action) => {
    pendingCourseAction.value = { course, action };
    showPartnershipWarningModal.value = true;
  };

  const handlePartnershipWarningConfirm = () => {
    if (pendingCourseAction.value) {
      const { course, action } = pendingCourseAction.value;
      showPartnershipWarningModal.value = false;
      pendingCourseAction.value = null;

      // Execute the original action with self-pay
      if (typeof action === 'function') {
        action(course, true); // force self-pay flag
      }
    }
  };

  const handlePartnershipWarningCancel = () => {
    showPartnershipWarningModal.value = false;
    pendingCourseAction.value = null;
  };

  const resetPartnershipWarning = () => {
    showPartnershipWarningModal.value = false;
    pendingCourseAction.value = null;
  };

  return {
    // Reactive state
    showPartnershipWarningModal,
    pendingCourseAction,

    // Methods
    shouldShowPartnershipWarning,
    handlePartnershipWarning,
    handlePartnershipWarningConfirm,
    handlePartnershipWarningCancel,
    resetPartnershipWarning
  };
}
